
import { QueryAndCountDto, WomeApplicationDto, WomeApplicationDtoQueryResultDto, WomeApplicationUpdateDto } from 'models/dtoTypes';
import { getWomeApplicationsApi, handleError } from 'services';


export const CreateWomeApplication = async (): Promise<WomeApplicationDto> => {
  const client = await getWomeApplicationsApi();
  const response = await client.createWomeApplication();
  return response.data;
};

export const GetManyWomeApplicationsAndCount = async (queryAndCountDto: QueryAndCountDto): Promise<WomeApplicationDtoQueryResultDto> => {
  const client = await getWomeApplicationsApi();
  const response = await client.getAllWomeApplications(queryAndCountDto);
  return response.data;
};

export const ApproveWomeApplication = async (womeId: string, updateDto?: WomeApplicationUpdateDto): Promise<WomeApplicationDto> => {
  try {
    const client = await getWomeApplicationsApi();
    const response = await client.approveWomeApplication(womeId, updateDto);
    return response.data;
  } catch (e) {
    return handleError(e);
  }
};

export const RejectWomeApplication = async (womeId: string, updateDto: WomeApplicationUpdateDto): Promise<WomeApplicationDto> => {
  const client = await getWomeApplicationsApi();
  const response = await client.rejectWomeApplication(womeId, updateDto);
  return response.data;
};

export const GetWomeApplication = async (id: string): Promise<WomeApplicationDto> => {
  const client = await getWomeApplicationsApi();
  const response = await client.getWomeApplication(id);
  return response.data;
};

export const DeleteWomeApplication = async (id: string): Promise<void> => {
  const client = await getWomeApplicationsApi();
  await client.deleteWomeApplication(id);
};
